export const ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
}

export const CELL_FORMAT_TYPE = {
  NUMBER: 'number',
  PERCENT_BAR: 'percent_bar',
  CONFIDENCE: 'confidence',
  TEXT: 'text'
}

export const TABLE_SPECIFIC_DATA_FIELDS = ['section', 'row', 'column', 'column_group', 'cell_format']
